let isMobile = window.innerWidth <= 992;

function checkForWindowSizeChange() {
  const wasMobile = isMobile;
  isMobile = window.innerWidth <= 992;

  if (wasMobile !== isMobile) {
    window.location.reload();
  }
}

function windowResize() {
  $(window).on('resize', checkForWindowSizeChange);
}

export default windowResize;


